export const adminData = {
  eventFields: [
    {
      name: 'Cam ID',
      key: 'camId'
    },
    {
      name: 'Event time',
      key: 'event_time'
    },
    {
      name: 'Name',
      key: 'name'
    },
    {
      name: 'Priority',
      key: 'priority'
    },
    {
      name: 'Reported priority',
      key: 'priorityReported'
    },
    {
      name: 'Type',
      key: 'type'
    },
    {
      name: 'Tags',
      key: 'tags'
    },
    {
      name: 'Event image',
      key: 'image'
    },   
    {
      name: 'Place name',
      key: 'placeName'
    },
  ],
  eventPriorities: [
    {
      name: 'Very low',
      keyLabel: 0,
    },
    {
      name: 'Low',
      keyLabel: 1,
    },
    {
      name: 'Medium',
      keyLabel: 2,
    },
    {
      name: 'High',
      keyLabel: 3,
    },
  ],
  eventImages: [
    {
      name: 'Primary Image',
      key: 'primaryImage',
    },
    {
      name: 'Secondary Image',
      key: 'secondaryImage'
    },
  ],
  priority: [
    'Very low','Low','Medium','High'
  ],
  priorityValues: [
    {
      label: 'VERY LOW',
      value: 0,
      color: '#50E3C2'
    },{
      label: 'LOW',
      value: 1,
      color: '#F8E71C'
    },
    {
      label: 'MEDIUM',
      value: 2,
      color: '#F5A623'
    },
    {
      label: 'HIGH',
      value: 3,
      color: '#B04457'
    }
  ],
  eventData: [
    {
      label: 'Very low and above',
      value: 0
    },
    {
      label: 'Low and above',
      value: 1
    },
    {
      label: 'Medium and above',
      value: 2
    },
    {
      label: 'High and above',
      value: 3
    },
  ],
  role: [
    {
      name: 'ADMIN',
    },
    {
      name: 'REGULAR',
    },
    {
      name: 'RESIDENT',
    },
  ],
  parking: [
    {
      vehicleNumber: 'MH 12 DE 3356',
      passType: 'Employee',
      entryImg: 'https://upload.wikimedia.org/wikipedia/commons/9/91/Niyamasabha.jpg',
      entryDate: '12/04/19',
      entryTime: '14:44',
      exitImg: 'https://upload.wikimedia.org/wikipedia/commons/9/91/Niyamasabha.jpg',
      exitDate: '12/04/19',
      exitTime: '14:55',
      duration: '22:02 hrs',
      vehicleType: 'Sedan',
      vehicleColor: 'Black'
    },
    {
      vehicleNumber: 'MH 12 DE 3356',
      passType: 'Employee',
      entryImg: 'https://upload.wikimedia.org/wikipedia/commons/9/91/Niyamasabha.jpg',
      entryDate: '12/04/19',
      entryTime: '14:44',
      exitImg: 'https://res.cloudinary.com/duv7nq4ge/image/upload/v1539118364/1_zuzivw.jpg',
      exitDate: '12/04/19',
      exitTime: '14:55',
      duration: '22:02 hrs',
      vehicleType: 'Sedan',
      vehicleColor: 'Red'
    },
    {
      vehicleNumber: 'MH 12 DE 3356',
      passType: 'Guest',
      entryImg: 'https://upload.wikimedia.org/wikipedia/commons/9/91/Niyamasabha.jpg',
      entryDate: '12/04/19',
      entryTime: '14:44',
      exitImg: '',
      exitDate: '12/04/19',
      exitTime: '14:55',
      duration: '22:02 hrs',
      vehicleType: 'Sedan',
      vehicleColor: 'White'
    },
  ],
  statParking: [
    {
      title: 'VEHICLES ENTERED',
      text: 234,
    },
    {
      title: 'VEHICLES EXITED',
      text: 112,
      subText: 'HRS'
    },
    {
      title: 'VEHICLES IN PARKING',
      text: 554,
      subText: 600
    },
  ]
}


// WEBPACK FOOTER //
// ./src/data/AdminData.js